;(function() {
  'use strict'

  angular.module('app.core').directive('glScrollClass', Directive)

  /* @ngInject */
  function Directive() {
    return {
      restrict: 'A',
      link: PostLink,
    }

    function PostLink(scope, elem, attrs) {
      var scrollClass = attrs.glScrollClass

      elem.on('scroll', _.throttle(checkClass, 100))
      scope.$watch(checkClass)

      var onResize = _.throttle(checkHorizontal, 100)
      angular.element(window).on('resize', onResize)
      scope.$on('$destroy', function() {
        angular.element(window).off('resize', onResize)
      })

      function checkClass() {
        checkVertical()
        checkHorizontal()
      }

      function checkVertical() {
        if (elem[0].scrollHeight > elem[0].clientHeight) {
          elem.addClass(scrollClass)

          if (elem[0].scrollTop > 0) {
            elem.addClass(scrollClass + '-top')
          } else {
            elem.removeClass(scrollClass + '-top')
          }

          if (elem[0].scrollTop + elem[0].clientHeight < elem[0].scrollHeight) {
            elem.addClass(scrollClass + '-bottom')
          } else {
            elem.removeClass(scrollClass + '-bottom')
          }
        } else {
          elem.removeClass(scrollClass)
          elem.removeClass(scrollClass + '-top')
          elem.removeClass(scrollClass + '-bottom')
        }
      }

      function checkHorizontal() {
        var node = elem[0]

        if (node.scrollWidth > node.clientWidth + 1) {
          elem.addClass(scrollClass + '-x')

          if (node.scrollLeft > 0) {
            elem.addClass(scrollClass + '-left')
          } else {
            elem.removeClass(scrollClass + '-left')
          }

          if (node.scrollLeft + node.clientWidth < node.scrollWidth - 1) {
            elem.addClass(scrollClass + '-right')
          } else {
            elem.removeClass(scrollClass + '-right')
          }
        } else {
          elem.removeClass(scrollClass + '-x')
          elem.removeClass(scrollClass + '-left')
          elem.removeClass(scrollClass + '-right')
        }
      }
    }
  }
})()
